module.exports = __webpack_public_path__ + "static/media/birthday.04a392de.png";